import React from 'react';
import SectionH2 from '../heading/SectionH2';
import iOSAppStore from '../../img/ios-app-store.svg';
import AndroidAppStore from '../../img/android-app-store.svg';
import Jewels from '../../img/jewels.png';
import Squiggles from '../../img/squiggles.png';
import { useAnalyticsEventTracker } from '../../utils/analytics';

const APP_STORE_IOS =
  'https://apps.apple.com/app/apple-store/id1513284627?pt=121388959&ct=Business%20Page&mt=8';
const PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.lowkeyclient&utm_source=business-page';

const BusinessDownload = () => {
  const eventTracker = useAnalyticsEventTracker('BusinessDownload');

  return (
    <div>
      <div class="max-w-screen-4xl mx-auto flex flex-row justify-center lg:px-12">
        <div
          style={{ boxShadow: 'inset 0 0 30px 12px #41E1B0' }}
          class="w-5/6 rounded-3xl border border-green-lowkey bg-gray-900 py-20 px-8 sm:w-4/5 sm:py-16 sm:px-0"
        >
          <div class="flex flex-row justify-center sm:px-10">
            <div class="hidden w-1/5 sm:visible sm:flex sm:flex-col sm:justify-center">
              <img loading="lazy" src={Jewels} alt={'Jewel decorations on the left'} class="object-contain" />
            </div>
            <div class="text-center sm:flex sm:w-2/3 sm:flex-col sm:justify-center">
              <div className="px-4 pb-1 sm:px-0 sm:pb-0">
                <SectionH2 title={'Start Your 14 Day Trial'} />
              </div>
              <div class="space-y-3 pb-10 font-space-grotesk-regular text-white sm:space-y-2 sm:pb-10 2xl:pb-12">
                <p class="sm:pt-0">
                  Download Lowkey today and automate entry across every building you manage.
                </p>
              </div>
              <div class="flex flex-col justify-center space-y-5 object-scale-down sm:h-12 sm:flex-row sm:justify-center sm:space-x-4 sm:space-y-0">
                <a href={APP_STORE_IOS} onClick={() => eventTracker('app_store_view', 'iOS', 'Download')}>
                  <img src={iOSAppStore} alt={'iOS App Store Download'} class="mx-auto h-12 sm:h-full" />
                </a>
                <a href={PLAY_STORE} onClick={() => eventTracker('app_store_view', 'android', 'Download')}>
                  <img src={AndroidAppStore} alt={'Google Play Store Download'} class="mx-auto h-12 sm:h-full" />
                </a>
              </div>
            </div>

            <div class="hidden w-1/5 sm:visible sm:flex sm:flex-col sm:justify-center">
              <img loading="lazy" src={Squiggles} alt={'Squiggle decorations on the right'} class="object-contain" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessDownload;
